import React, {cloneElement, memo} from "react";

const DisplayIf = ({children, condition, displayProp}) => {
    const display = displayProp || 'inline'

    if(!children)
        return null;
    if (children instanceof Array)
        return children.map((c, i) => <DisplayIf key={i} condition={condition} displayProp={display}>{c}</DisplayIf>)
    else return cloneElement(children, {
        ...children.props,
        style: {
            ...(children.props.style || {}),
            display: condition ? display : 'none'
        }
    });
}

export default memo(DisplayIf)